export const BRAND = {
  name: "Androgen Health",
  strapline: "Specialist testosterone care, delivered online.",
  positioning: "Specialist care. Clear costs. No pressure.",
  safety:
    "Treatment is subject to individual clinical assessment. TRT is not suitable for everyone.",
  pomNote:
    "Prescription-only medicines are not advertised on this website. Treatment is prescribed only where clinically appropriate, following assessment.",
};

export const NAV_LINKS = [
  { label: "Treatment", to: "/testosterone-treatment" },
  { label: "Testing", to: "/testosterone-testing" },
  { label: "Fees", to: "/trt-cost" },
  { label: "Safety", to: "/safety" },
  { label: "Learn", to: "/learn" },
  { label: "Tools", to: "/tools" },
  { label: "Team", to: "/clinical-team" },
];

export const MARQUEE_ITEMS = [
  "Clinically led",
  "Clear costs",
  "No pressure",
  "Assessment first",
  "Fertility counselling",
  "Long-term monitoring",
  "Independent advice",
  "UK specialist care",
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Tell us about your symptoms",
    copy: "A structured medical history and symptom review — completed online, at your pace. Fatigue, libido, mood, strength and sleep are all contextual clues, never a diagnosis on their own.",
  },
  {
    step: "02",
    title: "The right blood tests",
    copy: "An initial screening test, then a comprehensive morning panel where indicated — total and free testosterone, SHBG, LH, FSH and safety markers. Appropriately collected, properly interpreted.",
  },
  {
    step: "03",
    title: "A clear clinical assessment",
    copy: "A clinician reviews your history and results, explains what they show, and discusses whether treatment is appropriate — including when it is not, and why.",
  },
  {
    step: "04",
    title: "Ongoing care, if treated",
    copy: "Structured monitoring, planned reviews, prescription management and a named clinical team. Treatment is the start of a long-term relationship, not a delivery service.",
  },
];

export const SAFETY_PILLARS = [
  {
    title: "Fertility, discussed first",
    copy: "TRT can suppress sperm production. We discuss fertility intentions and preservation options before any treatment decision is made.",
  },
  {
    title: "Monitoring that means something",
    copy: "Testosterone levels, full blood count and haematocrit, and prostate-related assessment where appropriate — on a schedule, not on request.",
  },
  {
    title: "The freedom to say no",
    copy: "A patient may complete a full assessment and be appropriately advised that TRT is not indicated. That outcome is a success of the process, not a failure of the product.",
  },
  {
    title: "Clear escalation routes",
    copy: "Abnormal results and suspected serious adverse effects follow documented escalation protocols — including referral outside the service when needed.",
  },
];

export const FAQS = [
  {
    q: "How is low testosterone diagnosed in the UK?",
    a: "Low testosterone is diagnosed by considering symptoms, clinical history and appropriately collected blood tests. A single result may not be sufficient. Clinicians generally use morning testosterone measurements, often repeated to confirm a low result, alongside further assessment to establish the cause and whether treatment is appropriate.",
  },
  {
    q: "How much does TRT cost at Androgen Health?",
    a: "Proposed launch pricing is Foundation (oral tablets) at £99 per month, Precision (creams or depot injections) at £129 per month and Specialist (premium injectables, our most popular plan) at £179 per month. One-off assessment fees range from £35 for an initial screening blood test to £149 for a transfer assessment. Plans are monthly, with a clear cancellation policy.",
  },
  {
    q: "Is TRT suitable for everyone?",
    a: "No. Treatment is subject to individual clinical assessment and TRT is not suitable for everyone. Some patients complete an assessment and are appropriately advised that treatment is not indicated. Fertility implications, prostate health and other risks are discussed before any treatment decision.",
  },
  {
    q: "Can I transfer to Androgen Health from another TRT clinic?",
    a: "Yes. A transfer pathway is available for patients already receiving TRT elsewhere, subject to verification of diagnosis, prescription history, monitoring and suitability. The transfer assessment is £99 to £149.",
  },
  {
    q: "Do I need a blood test before starting treatment?",
    a: "Yes. Assessment begins with a testosterone screening blood test, followed where indicated by a comprehensive diagnostic panel — including morning testosterone, often repeated to confirm results — alongside other hormones and safety markers.",
  },
];

export const LEGAL = {
  provider: "High Street Health Ltd t/a Ready Health",
  companiesHouse: "15044189",
  address: "22 High Street, Standish, Wigan WN6 0HL",
  ico: "ZB729645",
  line: "Androgen Health services are provided by High Street Health Ltd t/a Ready Health, registered in England and Wales (Companies House 15044189), operating a CQC-registered private clinic at 22 High Street, Standish, Wigan WN6 0HL. ICO registration: ZB729645.",
};
